/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{margin:0 0 15px;font-size:1.5rem}.page-text[_ngcontent-%COMP%]{width:100%;font-size:.9rem}.page-text[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}"];
export { styles as styles };
